export const DATASOURCE_CONFIG = {
  DATASOURCE: "mysql", //redshift:redshift,mysql: mysql
  TABLE_PREFIX: "", //consent. - use "redshift: consent." prefix when datasource is redshift - "mysql: "
  CURRENT_DATE: "now()", // use "redshift: getdate()"  when datasource is redshift , mysql: now()
  CAMPAIGN_EXPIRY_INTERVAL: "INTERVAL 6 MONTH", // redshift: interval '6 months' / mysql: INTERVAL 6 MONTH
  REGEX: "REPLACE", //redshift: regexp_replace / mysql: REPLACE
  QUERY_LIKE: "like", // use "ilike"  when datasource is redshift, use "like"  when datasource is mysql
  CAMPAIGN_UNDEFINE_TIME: " OR expire_time='0000-00-00 00:00:00'  ", //mysql: OR expire_time='0000-00-00 00:00:00' =>  redshift:blank
  REQUEST_DATE_DIFF: "TIMESTAMPDIFF(DAY,r.updated_date,NOW())", //mysql:TIMESTAMPDIFF(DAY,r.updated_date,NOW()) //redshit : datediff(day,r.updated_date,current_date)
};

export const STRIPE_PAYMENT_CREDENTIALS = {
  stripe_secret_key: "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",
  stripe_publishable_key: "pk_live_51T9YMJJpjraLniW96N05xrhy43ahRRwn1dPak9v0CAIqvi0E61Tsj8VVXWEIzqJjhk2hgLxYsTDQgG7cE8ZBay5O0066hUk5cw",
};

export const DEFAULT_SHOW_ALL_CAMPAIGNS = false;
